class HelpBlockController {
  constructor (VehicleService, $translate, I18n) {
    'ngInject'

    this.vehicleService = VehicleService
    this.$translate = $translate
    this.I18n = I18n

    this.sections = []
    this.loaded = this.init()
  }

  init () {
    return this.vehicleService.getCurrentSelectedVehicle()
      .then((vehicle) => {
        this.model = vehicle ? vehicle.huType : null
        return this.loadSections(Array.from({length: 3}, (v, i) => i + 1))
      })
  }

  getTranslateKey (sectionNumber, field) {
    const section = 'section' + sectionNumber
    return `helpBlock.${this.model}.${section}.${field}`
  }

  loadSections (_sections) {
    return Promise.all(_sections.map((section) => {
      const key = this.getTranslateKey(section, 'title')
      return this.$translate(key)
      .then((trans) => trans ? section : null, () => Promise.resolve(null))
    }))
    .then((sections) => {
      this.sections = sections.filter((section) => !!section)
      .map((section) => ({
        title: this.getTranslateKey(section, 'title'),
        text: this.getTranslateKey(section, 'text'),
        video: this.getTranslateKey(section, 'video')
      }))
      return Promise.resolve(this.sections)
    })
  }
}

export default HelpBlockController



// WEBPACK FOOTER //
// ./src/app/common/help-block/help-block.controller.js